import React from "react";
import Landing from "./landing/Landing";

const HomePage = () => <Landing />;

export default HomePage;
